import { SmallScreenIllustration } from '@carboncopyco/illustrations';
import { Button, Spacer, TextBase, TextLargeParagraph } from '@carboncopyco/ui';

interface TourSmallScreenProps {
  onClose: () => void;
}

export const TourSmallScreen = ({ onClose }: TourSmallScreenProps) => {
  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full w-full z-1000 bg-white">
      <SmallScreenIllustration />
      <Spacer amount={2} />
      <TextLargeParagraph
        label="Your screen is too small"
        color="text-ds-natural-600"
      />
      <Spacer amount={1} />
      <div className="w-92 text-center">
        <TextBase
          label="It looks like your screen is too small for the experience, some objects may look different"
          color="text-ds-natural-300"
        />
      </div>
      <Spacer amount={3} />
      <Button
        label="View in current resolution"
        onClick={onClose}
        secondary
      />
    </div>
  );
};
